import * as Yup from 'yup';

import { passwordRegex } from '../../../constants';

export const addCompanyUserFormYopValidation = () => {
  return Yup.object().shape({
    firstName: Yup.string().required('required'),
    lastName: Yup.string().required('required'),
    username: Yup.string().required('required').email('incorrectEmail'),
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
  });
};
